<script setup lang="ts">
import { useI18n } from '@/hooks/web/useI18n';
import { ElDialog,ElProgress } from 'element-plus'
import { ref } from 'vue';
const { t } = useI18n()

const props = defineProps({
  percentage: {type: Number, default: 0},
  title: {type: String, default: ''},
  width: {type: String, default: '556px'},
  color : {type: String, default: 'var(--c-primary)'},
  showClose: {type: Boolean, default: true},
  showCancel: {type: Boolean, default: true},
  showConfirm: {type: Boolean, default: false},
  cancelText: {type: String, default: ''},
  confirmText: {type: String, default: ''},
  cancelColor: {type: String, default: 'var(--c-gray-dark)'},
  confirmActiveColor: {type: String, default: 'var(--left-menu-text-active-color)'},
  canConfirm: {type: Boolean, default: true},
  errMessage: {type: String, default: ''},
})

const open = () => {
  _show.value = true
}
const close = () => {
  _show.value = false
}
const cancel = () => {
  close()
}
const confirm = () => {
  close()
}

const _show = ref(false)

defineExpose({
  open,
  close
})
</script>

<template>
  <ElDialog
    class="asp-dialog"
    v-model="_show"
    :width="width"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @open="open"
    @close="close">
    <div class="h-full flex flex-col">
      <!-- title -->
      <div v-if="!$slots.title" class="h-76px flex-shrink-0 flex-grow-0 px-[24px] py-[17px] box-border bg-[var(--c-content-bg-gray)]">
        <div class="text-[20px] font-bold text-[var(--c-txt)]">{{title}}</div>
        <img v-if="showClose" class="w-[16px] h-[16px] absolute top-17px right-17px cursor-pointer" src="@/assets/icons/icon-dialog-close.svg" @mousedown="_show = false"/>
      </div>
      <div v-if="$slots.title" class="flex-shrink-0 flex-grow-0 flex items-center box-border">
        <slot name="title"></slot>
        <img v-if="showClose" class="w-[16px] h-[16px] absolute top-17px right-17px cursor-pointer" src="@/assets/icons/icon-dialog-close.svg" @mousedown="_show = false"/>
      </div>
      
      <!-- body -->
      <div class="flex-1 overflow-auto bg-[var(--c-white)] box-border">
        <el-progress :percentage="percentage" :show-text="false" stroke-linecap="square" :stroke-width="4" :color="color"/>
        <div v-if="errMessage" class="px-24px py-20px">
          <div class="px-20px py-20px min-h-200px text-14px text-[var(--c-dark-txt)]" style="border: 1px solid var(--c-info-crd-txt-fault);">
            {{ errMessage }}
          </div>
        </div>
      </div>
      <!-- footer -->
      <div class="flex-shrink-0 flex-grow-0 h-[56px] flex items-center justify-end px-24px box-border font-bold bg-[var(--c-content-bg-gray)] border-t-[1px] border-[var(--c-card-content-border-gray)]">
        <Button v-if="showCancel" @click="cancel" type="primary" plain class="text-var(--c-bg-dark-txt)">
          <div>{{props.cancelText?props.cancelText:t('common.Cancel')}}</div>
        </Button>
        <Button v-if="showConfirm" @click="confirm" type="primary" class="text-var(--c-bg-dark-txt)">
          <div>{{props.confirmText?props.confirmText:t('common.Confirm')}}</div>
        </Button>
      </div>
    </div>
  </ElDialog>
</template>

<style lang="less" scoped>
:deep(.el-progress-bar__outer) {
  background-color: transparent;
}
</style>